export default __webpack_public_path__ + "static/media/logo.2724e793.svg";